/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Share_Shared1Inputs */

const en_coinvestments_share_shared1 = /** @type {(inputs: Coinvestments_Share_Shared1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shared`)
};

/**
* | output |
* | --- |
* | "Shared" |
*
* @param {Coinvestments_Share_Shared1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_share_shared1 = /** @type {((inputs?: Coinvestments_Share_Shared1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Share_Shared1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_share_shared1(inputs)
});
export { coinvestments_share_shared1 as "coInvestments_share_shared" }